module.exports = __webpack_public_path__ + "static/media/02.40fba95f.png";